import * as yup from "yup";

export const PermittedUseSchema = yup.object({
  title: yup.string().required(),
  description: yup.string(),
});

export type PermittedUseType = yup.InferType<typeof PermittedUseSchema>;
